/* eslint-disable no-redeclare */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import axios from "axios";
import moment from "moment";
import API_URL from "../../constants/API_URL";
import Swal from "sweetalert2";
import QRCode from "qrcode";

let sendDynamicPrintToServer = async (_data, type) => {
  try {
    const branch = JSON.parse(localStorage.getItem("branch_data") || "{}");
    const clientId = localStorage.getItem("clientId");

    const payload = {
      clientId: String(clientId),
      branch: String(branch.id),
      printType: type,
      invoice:
        type === "ORDER_RECEIPT" ||
        type === "KITCHEN" ||
        type === "REFUND" ||
        type === "CHECK_PRINT" ||
        type === "DUPLICATE"
          ? _data
          : null,
      barcode: type === "BARCODE" ? _data : null,
      cashup: type === "CASHUP" ? _data : null,
    };

    const { data } = await axios({
      url: API_URL + "kafka/publishPrint",
      method: "POST",
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return data;
    console.log("✅ Sent successfully:", data);
  } catch (error) {
    console.log("❌ API Error:", error);
  }
};

let sendKitchenPrintToServer = async (data) => {
  await sendDynamicPrintToServer(data, "KITCHEN");
};

let sendRefundPrintToServer = async (data, ip) => {
  await sendDynamicPrintToServer(data, "REFUND");
};

let createKitchenSlip = async (dataPrint, param, isPrntKitchenOnPayment) => {
  if (dataPrint.data.isPrntBarcode && dataPrint.branch.isBarcodeEnable) {
    let newLines = [];
    let productList = [
      ...dataPrint.posProductList.filter(
        (item) => item.isBarcodeProduct == true,
      ),
    ];
    let lines;
    if (param === "cancelItemInKitchen") {
      lines = dataPrint.line.filter((item) => item.status == "C");
    } else {
      if (isPrntKitchenOnPayment) {
        lines = dataPrint.line.filter((item) => item.status != "C");
      } else {
        lines = dataPrint.line.filter((item) => item.status == "DR");
      }
    }
    console.log(lines);
    lines.map((item) => {
      if (
        item.isGroupItem == false &&
        item.isAddProduct == false &&
        productList.length > 0 &&
        productList.filter((i) => i.id === item.product).length > 0 &&
        productList.filter((i) => i.id === item.product)[0].isBarcodeProduct
      ) {
        let newlineschild = [];
        lines.forEach((ii) => {
          if (item.isGroupItem == false || item.isAddProduct == false) {
            if (ii.parentProduct == item.id) {
              let nameAr =
                productList.length > 0 &&
                productList.filter((i) => i.id === ii.product).length > 0 &&
                productList.filter((i) => i.id === ii.product)[0].nameAr
                  ? productList.length > 0 &&
                    productList.filter((i) => i.id === ii.product).length > 0 &&
                    productList.filter((i) => i.id === ii.product)[0].nameAr
                  : "";
              let name =
                productList.length > 0 &&
                productList.filter((i) => i.id === ii.product).length > 0 &&
                productList.filter((i) => i.id === ii.product)[0].name
                  ? productList.length > 0 &&
                    productList.filter((i) => i.id === ii.product).length > 0 &&
                    productList.filter((i) => i.id === ii.product)[0].name
                  : "";
              newlineschild.push({ name, nameAr, qty: ii.qty });
            }
          }
        });
        let nameAr =
          productList.length > 0 &&
          productList.filter((i) => i.id === item.product).length > 0 &&
          productList.filter((i) => i.id === item.product)[0].nameAr
            ? productList.filter((i) => i.id === item.product)[0].nameAr
            : "";
        let name =
          productList.length > 0 &&
          productList.filter((i) => i.id === item.product).length > 0 &&
          productList.filter((i) => i.id === item.product)[0].name
            ? productList.filter((i) => i.id === item.product)[0].name
            : "";
        newLines.push({ name, nameAr, qty: item.qty });
      }
    });
    let data = {
      orderNo: dataPrint.orderNo,
      printer: dataPrint.data.name,
      products: [...newLines],
      clientName: localStorage.getItem("client_name"),
    };
    await sendDynamicPrintToServer(data, "BARCODE");
  }
  let newLines = [];
  if (dataPrint.data.isPrntAllCat) {
    let lines;
    if (param === "cancelItemInKitchen") {
      lines = dataPrint.line.filter((item) => item.status == "C");
    } else {
      if (isPrntKitchenOnPayment) {
        lines = dataPrint.line.filter((item) => item.status != "C");
      } else {
        lines = dataPrint.line.filter((item) => item.status == "DR");
      }
    }
    lines.map((item) => {
      if (item.isGroupItem == false && item.isAddProduct == false) {
        let newlineschild = [];
        lines.forEach((ii) => {
          if (item.isGroupItem == false || item.isAddProduct == false) {
            if (ii.parentProduct == item.id) {
              let nameAr =
                dataPrint.productList.length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)
                  .length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)[0]
                  .nameAr
                  ? dataPrint.productList.filter((i) => i.id === ii.product)[0]
                      .nameAr
                  : "";
              let name =
                dataPrint.productList.length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)
                  .length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)[0].name
                  ? dataPrint.productList.filter((i) => i.id === ii.product)[0]
                      .name
                  : "";
              newlineschild.push({ name, nameAr, qty: ii.qty });
            }
          }
        });
        let nameAr =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].nameAr
            ? dataPrint.productList.filter((i) => i.id === item.product)[0]
                .nameAr
            : "";
        let name =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].name
            ? dataPrint.productList.filter((i) => i.id === item.product)[0].name
            : "";
        newLines.push({
          notes: item.notes,
          name,
          nameAr,
          qty: item.qty,
          items: [...newlineschild],
        });
      }
    });
    console.log("newLines", newLines);
    var data = {
      header: dataPrint.header,
      footer: dataPrint.footer,
      orderNo: dataPrint.orderNo,
      floorName: dataPrint.floorName
        ? dataPrint.floorName
        : localStorage.getItem("floorName"),
      tableName: dataPrint.tableName
        ? dataPrint.tableName
        : localStorage.getItem("tableName"),
      printer: dataPrint.data.name,
      lines: [...newLines],
      tokenNo: dataPrint.tokenNo,
      cancel: false,
    };
    if (param === "cancelItemInKitchen") {
      data.cancel = true;
    }

    sendKitchenPrintToServer(data, dataPrint.data.ipAddr);
  } else {
    let lines;
    if (param === "cancelItemInKitchen") {
      lines = dataPrint.line.filter((item) => item.status == "C");
    } else {
      if (isPrntKitchenOnPayment) {
        lines = dataPrint.line.filter((item) => item.status != "C");
      } else {
        lines = dataPrint.line.filter((item) => item.status == "DR");
      }
    }
    for (let it = 0; it <= dataPrint.data.categories.length - 1; it++) {
      // eslint-disable-next-line no-loop-func

      lines.map((item) => {
        if (item.isGroupItem == false && item.isAddProduct == false) {
          let comp = dataPrint.data.categories[it];
          let comp1 =
            dataPrint.posProductList.length > 0 &&
            dataPrint.posProductList.filter((i) => i.id === item.product)
              .length > 0 &&
            dataPrint.posProductList.filter((i) => i.id === item.product)[0]
              .categoryId;
          if (comp == comp1) {
            let newlineschild = [];
            lines.forEach((ii) => {
              if (item.isGroupItem == false || item.isAddProduct == false) {
                if (ii.parentProduct == item.id) {
                  let nameAr =
                    dataPrint.productList.length > 0 &&
                    dataPrint.productList.filter((i) => i.id === ii.product)
                      .length > 0 &&
                    dataPrint.productList.filter((i) => i.id === ii.product)[0]
                      .nameAr
                      ? dataPrint.productList.filter(
                          (i) => i.id === ii.product,
                        )[0].nameAr
                      : "";
                  let name =
                    dataPrint.productList.length > 0 &&
                    dataPrint.productList.filter((i) => i.id === ii.product)
                      .length > 0 &&
                    dataPrint.productList.filter((i) => i.id === ii.product)[0]
                      .name
                      ? dataPrint.productList.filter(
                          (i) => i.id === ii.product,
                        )[0].name
                      : "";
                  newlineschild.push({ name, nameAr, qty: ii.qty });
                }
              }
            });
            let nameAr =
              dataPrint.productList.length > 0 &&
              dataPrint.productList.filter((i) => i.id === item.product)
                .length > 0 &&
              dataPrint.productList.filter((i) => i.id === item.product)[0]
                .nameAr
                ? dataPrint.productList.filter((i) => i.id === item.product)[0]
                    .nameAr
                : "";
            let name =
              dataPrint.productList.length > 0 &&
              dataPrint.productList.filter((i) => i.id === item.product)
                .length > 0 &&
              dataPrint.productList.filter((i) => i.id === item.product)[0].name
                ? dataPrint.productList.filter((i) => i.id === item.product)[0]
                    .name
                : "";
            newLines.push({
              notes: item.notes,
              name,
              nameAr,
              qty: item.qty,
              items: [...newlineschild],
            });
          }
        }
      });
    }
    if (newLines.length > 0) {
      var data = {
        header: dataPrint.header,
        footer: dataPrint.footer,
        orderNo: dataPrint.orderNo,
        floorName: dataPrint.floorName
          ? dataPrint.floorName
          : localStorage.getItem("floorName"),
        tableName: dataPrint.tableName
          ? dataPrint.tableName
          : localStorage.getItem("tableName"),
        printer: dataPrint.data.name,
        lines: [...newLines],
        customer: dataPrint.customer,
        tokenNo: dataPrint.tokenNo,
        cancel: false,
      };
      if (param === "cancelItemInKitchen") {
        data.cancel = true;
      }
      sendKitchenPrintToServer(data, dataPrint.data.ipAddr);
    }
  }
};

let createRefundSlip = (dataPrint) => {
  let totalWithoutTax = 0;
  let total = 0;
  let newLines = [];
  let lines = dataPrint.line;
  lines.map((item) => {
    // console.log(item)
    if (item.refundQty > 0 && item.isComboChild == false) {
      let pp, name, nameAr, price;
      console.log(item);
      if (item.isCombo) {
        pp = item.priceWithoutTax;
        price = item.unitPrice;
        nameAr =
          dataPrint.comboList.length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo).length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo)[0].nameAr;
        name =
          dataPrint.comboList.length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo).length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo)[0].name;
        // console.log(pp, name, nameAr)
      } else {
        price = item.unitPrice;
        pp = item.priceWithoutTax;
        nameAr =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].nameAr;
        name =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].name;
      }
      totalWithoutTax = totalWithoutTax + pp * item.refundQty;
      total = total + price * item.refundQty;
      newLines.push({
        name: name,
        nameAr: nameAr,
        qty: item.refundQty,
        // priceWithoutTax: pp * item.refundQty,
        priceWithoutTax: pp,
        totalNetLine: parseFloat((item.unitPrice * item.refundQty).toFixed(2)),
        unitPrice: item.unitPrice,
        // items: [...newlineschild]
        items: [],
      });
    }
  });
  // console.log(newLines)
  // let paymeAmount = dataPrint.paymeAmount  ? dataPrint.paymeAmount  : 0
  var data = {
    header: dataPrint.header,
    footer: dataPrint.footer,
    orderNo: dataPrint.orderNo,
    floorName: dataPrint.floorName
      ? dataPrint.floorName
      : localStorage.getItem("floorName"),
    tableName: dataPrint.tableName
      ? dataPrint.tableName
      : localStorage.getItem("tableName"),
    printer: dataPrint.data.name,
    lines: [...newLines],
    cashier: JSON.parse(localStorage.getItem("userData")).name,
    //   totalWithoutTax: parseFloat(totalWithoutTax),
    tax: dataPrint.tax,
    total: total,
    // customerPayAmount:  parseFloat((paymeAmount).toFixed(2)) ,
    // remainingAmount: parseFloat((- dataPrint.totalNet + parseFloat((paymeAmount).toFixed(2))).toFixed(2)),
    refund: dataPrint.refundAmount,
    customer: dataPrint.customer,
    tokenNo: dataPrint.tokenNo,
  };
  data.taxNo = localStorage.getItem("taxNo")
    ? localStorage.getItem("taxNo")
    : "";
  console.log(data);
  sendRefundPrintToServer(data, dataPrint.data.ipAddr);
};

let sendPaymentPrintToServer = async (datA, ip, param) => {
  const data = { ...datA };
  const tobacco = JSON.parse(
    localStorage.getItem("saveSaleOrderTobacco") || "{}",
  );
  let url;
  data.tobaccoFeeBeforeTax = tobacco.netLineWithoutTax;
  data.tobaccoFeeAfterTax = tobacco.totalNetLine;
  data.tax = Number(localStorage.getItem("totalTax"));
  console.log("param ----------------->", param);

  if (param == "payment" || param == "rPrint") {
    url = "ORDER_RECEIPT";
  }
  if (param == "cPrint") {
    url = "CHECK_PRINT";
  }
  if (param == "cDuplicate") {
    url = "DUPLICATE";
  }
  await sendDynamicPrintToServer(data, url);
};

let createReceiptSlip = (dataPrint, param) => {
  let totalWithoutTax = 0;
  let newLines = [];
  let lines = dataPrint.line.filter((i) => i.status != "C");
  lines.map((item) => {
    if (
      item.isGroupItem == false &&
      item.isAddProduct == false &&
      item.isComboChild == false
    ) {
      let newlineschild = [];
      lines.forEach((ii) => {
        if (
          item.isGroupItem == false ||
          item.isAddProduct == false ||
          item.isComboChild == false
        ) {
          if (ii.parentProduct == item.id) {
            if (ii.isComboChild == false) {
              let pp;
              pp = ii.priceWithoutTax;
              totalWithoutTax = totalWithoutTax + pp * ii.qty;
              console.log(totalWithoutTax);
              let nameAr =
                dataPrint.productList.length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)
                  .length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)[0]
                  .nameAr;
              let name =
                dataPrint.productList.length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)
                  .length > 0 &&
                dataPrint.productList.filter((i) => i.id === ii.product)[0]
                  .name;
              newlineschild.push({
                name: name,
                nameAr: nameAr,
                // priceWithoutTax: pp * ii.qty,
                priceWithoutTax: pp,
                qty: ii.qty,
                totalNetLine: parseFloat(ii.totalNetLine.toFixed(2)),
                unitPrice: ii.unitPrice,
              });
            }
          }
        }
      });
      let pp, nameAr, name;
      if (item.combo) {
        pp = item.priceWithoutTax;
        nameAr =
          dataPrint.comboList.length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo).length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo)[0].nameAr;
        name =
          dataPrint.comboList.length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo).length > 0 &&
          dataPrint.comboList.filter((i) => i.id === item.combo)[0].name;
      } else {
        pp = item.priceWithoutTax;
        nameAr =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].nameAr;
        name =
          dataPrint.productList.length > 0 &&
          dataPrint.productList.filter((i) => i.id === item.product).length >
            0 &&
          dataPrint.productList.filter((i) => i.id === item.product)[0].name;
      }
      totalWithoutTax = totalWithoutTax + pp * item.qty;
      newLines.push({
        name: name,
        nameAr: nameAr,
        qty: item.qty,
        // priceWithoutTax: pp * item.qty,
        priceWithoutTax: pp,
        totalNetLine: parseFloat(item.totalNetLine.toFixed(2)),
        unitPrice: item.unitPrice,
        items: [...newlineschild],
      });
    }
  });
  let paymeAmount = dataPrint.paymeAmount ? dataPrint.paymeAmount : 0;
  let totalAnount = 0;
  if (param == "rPrint" || param == "cDuplicate") {
    totalAnount = dataPrint.totalNet;
  } else {
    totalAnount = dataPrint.actualAmt;
  }

  let cashPaidAmount = dataPrint.cashPaidAmount ? dataPrint.cashPaidAmount : 0;

  var data = {
    header: dataPrint.header,
    footer: dataPrint.footer,
    orderNo: dataPrint.orderNo,
    deliveryPerson: dataPrint.deliveryPerson,
    orderType: dataPrint.orderType,
    floorName: dataPrint.floorName
      ? dataPrint.floorName
      : localStorage.getItem("floorName"),
    tableName: dataPrint.tableName
      ? dataPrint.tableName
      : localStorage.getItem("tableName"),
    printer: dataPrint.data.name,
    lines: [...newLines],
    totalWithoutTax: parseFloat(totalWithoutTax),
    tax: dataPrint.taxAmt,
    taxAmt: dataPrint.taxAmt,
    total: dataPrint.totalNet.toFixed(2),
    customerPayAmount: parseFloat(dataPrint.payCash),
    remainingAmount: 0,
    cashier: JSON.parse(localStorage.getItem("userData")).name,
    customer: dataPrint.customer,
    tokenNo: dataPrint.tokenNo,
    couponNo: dataPrint.couponNo,
    discountAmt: dataPrint.discountAmt,
    actualAmt: dataPrint.actualAmt,
    extraCharge: 0,
    paidAmt: dataPrint.paidAmt,
    orderId: dataPrint.orderId,
    qrcode: dataPrint.qrcode,
    address: dataPrint.address,
    branch: dataPrint.branch,
  };
  if (param == "rPrint" || param == "cPrint" || param == "cDuplicate") {
    data.orderDate = moment(dataPrint.orderDate).format("YYYY-MM-DD hh:mm A");
  }
  if (parseFloat(dataPrint.payCash) > parseFloat(cashPaidAmount)) {
    data.remainingAmount = parseFloat(
      (parseFloat(dataPrint.payCash) - parseFloat(cashPaidAmount)).toFixed(2),
    );
  }
  if (dataPrint.isMinCharge && dataPrint.paidAmt > dataPrint.actualAmt) {
    data.extraCharge = (dataPrint.paidAmt - dataPrint.actualAmt).toFixed(2);
    if (dataPrint.isTaxOnChrg) {
      let tax = data.extraCharge * (dataPrint.taxRate / 100);
      data.tax = (data.tax + tax).toFixed(2);
    }
  }
  data.taxNo = localStorage.getItem("taxNo")
    ? localStorage.getItem("taxNo")
    : "";

  sendPaymentPrintToServer(data, dataPrint.data.ipAddr, param);
};

export const buildMessage = async (
  line,
  data,
  productList,
  tables,
  floors,
  printer_models,
  param,
  paymeAmount,
  customerList,
  cashPaidAmount,
  comboList,
  posProductListForKitchen,
  posStorageAction,
  isPrntKitchenOnPayment,
  deliveryPerson,
) => {
  var tableName =
    tables.length > 0 &&
    tables.filter((i) => i.id === data.flrTable).length > 0 &&
    tables.filter((i) => i.id === data.flrTable)[0].name;
  var floor =
    tables.length > 0 &&
    tables.filter((i) => i.id === data.flrTable).length > 0 &&
    tables.filter((i) => i.id === data.flrTable)[0].floor;
  var floorName =
    floors.length > 0 &&
    floors.filter((i) => i.id === floor).length > 0 &&
    floors.filter((i) => i.id === floor)[0].name;
  var customer =
    customerList.length > 0 &&
    customerList.filter((i) => i.id == data.customer).length > 0 &&
    customerList.filter((i) => i.id == data.customer)[0].name;

  if (tableName) await localStorage.setItem("tableName", tableName);
  if (floorName) await localStorage.setItem("floorName", floorName);

  if (param == "payment") {
    Swal.fire({
      title: "هل تريد الطباعة",
      icon: "success",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "نعم اطبع",
      cancelButtonText: "الغاء",
    }).then(async (result) => {
      if (result.isConfirmed) {
        var branch = JSON.parse(
          JSON.parse(localStorage.getItem("persist:root")).user,
        ).branchId;
        var headerANDfooter = {};
        var qrcode = null;

        await axios({
          url: API_URL + "branchByID",
          method: "GET",
          params: {
            id: branch,
            lang: localStorage.getItem("lang"),
          },
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }).then((result) => {
          headerANDfooter = result.data.object;
        });

        // [Othman] get qr code
        await axios({
          url: API_URL + `zatca-integration/get-QRCode`,
          method: "POST",
          params: {
            orderId: data.id,
          },
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        })
          .then((resQr) => {
            qrcode = resQr.data.object;
          })
          .catch((err) => {
            console.log("error from get qr code");
          });

        await axios({
          url: API_URL + "printerListByBranch",
          method: "GET",
          params: {
            branchId: branch,
          },
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        })
          .then(async (res) => {
            for (let i = 0; i <= res.data.length - 1; i++) {
              let ot = "";
              if (data.orderType == "TA") {
                ot = "Take Away";
              }
              if (data.orderType == "OL") {
                ot = "Online";
              }
              if (data.orderType == "DI") {
                ot = "Dine In";
              }
              if (data.orderType == "HD") {
                ot = "Home Delivery";
              }
              let isPrntTakeaway = data.orderType == "TA" ? true : false;
              let isPrntOnline = data.orderType == "OL" ? true : false;
              let isPrntDinein = data.orderType == "DI" ? true : false;
              let isPrntDelivery = data.orderType == "HD" ? true : false;
              let ca =
                res.data[i].isPrntDelivery == isPrntDelivery &&
                isPrntDelivery == true;
              let cb =
                res.data[i].isPrntDinein == isPrntDinein &&
                isPrntDinein == true;
              let cc =
                res.data[i].isPrntTakeaway == isPrntTakeaway &&
                isPrntTakeaway == true;
              let co =
                res.data[i].isPrntOnline == isPrntOnline &&
                isPrntOnline == true;
              var printerModel = res.data[i].printerModel;
              var isPrntReciept = res.data[i].isPrntReciept;

              if (ca || cb || cc || co) {
                if (res.data[i].isPrntKitchen) {
                  if (param == "kitchen" || param == "cancelItemInKitchen") {
                    let dataPrint = {
                      header: headerANDfooter.header,
                      footer: headerANDfooter.footer,
                      orderNo: data.documentNo,
                      branch: headerANDfooter,
                      floorName,
                      tableName,
                      data: res.data[i],
                      productList,
                      line,
                      printerModel: printerModel,
                      customer: customer,
                      printer_models: [...printer_models],
                      tokenNo: data.tokenNo,
                      posProductList: posProductListForKitchen,
                    };

                    createKitchenSlip(dataPrint, param, isPrntKitchenOnPayment);
                  }
                }
                if (isPrntReciept) {
                  console.log("#".repeat(40), param);

                  if (
                    param == "payment" ||
                    param == "rPrint" ||
                    param == "cPrint" ||
                    param == "cDuplicate"
                  ) {
                    if (localStorage.getItem("printer") != "null") {
                      if (res.data[i].id != localStorage.getItem("printer")) {
                        continue;
                      }
                    }

                    const branch_data = localStorage.getItem("branch_data");
                    const branch_data_json = JSON.parse(branch_data || "{}");
                    let dataPrint = {
                      header: headerANDfooter.header,
                      footer: headerANDfooter.footer,
                      orderNo: data.documentNo,
                      orderId: data.id,
                      floorName,
                      orderType: ot,
                      orderDate: data.orderDate,
                      deliveryPerson,
                      tableName,
                      totalNet: data.totalNet,
                      data: res.data[i],
                      productList,
                      line,
                      paymeAmount,
                      printerModel: printerModel,
                      printer_models: [...printer_models],
                      customer: customer,
                      tokenNo: data.tokenNo,
                      couponNo: data.couponNo,
                      discountAmt: data.discountAmt,
                      taxAmt: data.taxAmt,
                      actualAmt: data.actualAmt,
                      isMinCharge: data.isMinCharge,
                      minCharge: data.minCharge,
                      paidAmt: data.paidAmt,
                      chargeType: data.chargeType,
                      isTaxOnChrg: data.isTaxOnChrg,
                      taxRate: data.taxRate,
                      payCash: data.payCash,
                      cashPaidAmount: cashPaidAmount,
                      comboList,
                      tax: data.taxAmt,
                      address: branch_data_json.address,
                      branch: branch_data_json.nameAr,
                      qrcode: qrcode,
                    };
                    createReceiptSlip(dataPrint, param);

                    if (headerANDfooter.popupBeforePrint) {
                      const htmlContent = await generateInvoiceHTML(dataPrint);
                      Swal.fire({
                        title: "رسالة تأكيد",
                        html: `
            <div style="max-height: 70vh; overflow-y: auto; text-align: right;">
              ${htmlContent}
            </div>
          `,
                        showCancelButton: true,
                        showConfirmButton: true,
                        confirmButtonText: "🖨️ طباعة",
                        cancelButtonText: "إلغاء",
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        width: "800px",
                        customClass: {
                          popup: "invoice-popup",
                        },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                      }).then(async (result) => {
                        if (result.isConfirmed) {
                          if (param == "payment") {
                            posStorageAction({ pos: true });
                          }
                          const printWindow = window.open("", "_blank");
                          printWindow.document.write(`
              <html>
                <head>
                  <title>فاتورة</title>
                  <style>
                    body { font-family: Arial, sans-serif; direction: rtl; margin: 0; padding: 0; }
                  </style>
                </head>
                <body>
                  ${htmlContent}
                  <script>
                    window.onload = function() {
                      window.print();
                      window.onafterprint = function() { window.close(); }
                    }
                  </script>
                </body>
              </html>
            `);
                          printWindow.document.close();
                        } else {
                          if (param == "payment") {
                            posStorageAction({ pos: true });
                          }
                        }
                      });
                    } else {
                      if (param == "payment") {
                        posStorageAction({ pos: true });
                      }
                    }
                  } else if (param == "refund") {
                    let dataPrint = {
                      header: headerANDfooter.header,
                      footer: headerANDfooter.footer,
                      orderNo: data.documentNo,
                      floorName,
                      tableName,
                      totalNet: data.totalNet,
                      data: res.data[i],
                      productList,
                      line,
                      refundAmount: data.refundAmt,
                      printerModel: printerModel,
                      printer_models: [...printer_models],
                      customer: customer,
                      tokenNo: data.tokenNo,
                      tax: data.taxAmt,
                      comboList,
                    };
                    createRefundSlip(dataPrint);
                  }
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  } else {
    var branch = JSON.parse(
      JSON.parse(localStorage.getItem("persist:root")).user,
    ).branchId;
    var headerANDfooter = {};
    var qrcode = null;
    await axios({
      url: API_URL + "branchByID",
      method: "GET",
      params: {
        id: branch,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((result) => {
      headerANDfooter = result.data.object;
    });

    // [Othman] get qr code
    await axios({
      url: API_URL + `zatca-integration/get-QRCode`,
      method: "POST",
      params: {
        orderId: data.id,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((resQr) => {
        qrcode = resQr.data.object;
      })
      .catch((err) => {
        console.log("error from get qr code");
      });

    var tableName =
      tables.length > 0 &&
      tables.filter((i) => i.id === data.flrTable).length > 0 &&
      tables.filter((i) => i.id === data.flrTable)[0].name;
    var floor =
      tables.length > 0 &&
      tables.filter((i) => i.id === data.flrTable).length > 0 &&
      tables.filter((i) => i.id === data.flrTable)[0].floor;
    var floorName =
      floors.length > 0 &&
      floors.filter((i) => i.id === floor).length > 0 &&
      floors.filter((i) => i.id === floor)[0].name;
    var customer =
      customerList.length > 0 &&
      customerList.filter((i) => i.id == data.customer).length > 0 &&
      customerList.filter((i) => i.id == data.customer)[0].name;

    await axios({
      url: API_URL + "printerListByBranch",
      method: "GET",
      params: {
        branchId: branch,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        for (let i = 0; i <= res.data.length - 1; i++) {
          let ot = "";
          if (data.orderType == "TA") {
            ot = "Take Away";
          }
          if (data.orderType == "OL") {
            ot = "Online";
          }
          if (data.orderType == "DI") {
            ot = "Dine In";
          }
          if (data.orderType == "HD") {
            ot = "Home Delivery";
          }
          let isPrntTakeaway = data.orderType == "TA" ? true : false;
          let isPrntOnline = data.orderType == "OL" ? true : false;
          let isPrntDinein = data.orderType == "DI" ? true : false;
          let isPrntDelivery = data.orderType == "HD" ? true : false;
          let ca =
            res.data[i].isPrntDelivery == isPrntDelivery &&
            isPrntDelivery == true;
          let cb =
            res.data[i].isPrntDinein == isPrntDinein && isPrntDinein == true;
          let cc =
            res.data[i].isPrntTakeaway == isPrntTakeaway &&
            isPrntTakeaway == true;
          let co =
            res.data[i].isPrntOnline == isPrntOnline && isPrntOnline == true;
          var printerModel = res.data[i].printerModel;
          var isPrntReciept = res.data[i].isPrntReciept;

          if (ca || cb || cc || co) {
            if (res.data[i].isPrntKitchen) {
              if (param == "kitchen" || param == "cancelItemInKitchen") {
                let dataPrint = {
                  header: headerANDfooter.header,
                  footer: headerANDfooter.footer,
                  orderNo: data.documentNo,
                  branch: headerANDfooter,
                  floorName,
                  tableName,
                  data: res.data[i],
                  productList,
                  line,
                  printerModel: printerModel,
                  customer: customer,
                  printer_models: [...printer_models],
                  tokenNo: data.tokenNo,
                  posProductList: posProductListForKitchen,
                };
                createKitchenSlip(dataPrint, param, isPrntKitchenOnPayment);
              }
            }
            if (isPrntReciept) {
              console.log("#".repeat(40), param);

              if (
                param == "payment" ||
                param == "rPrint" ||
                param == "cPrint" ||
                param == "cDuplicate"
              ) {
                if (localStorage.getItem("printer") != "null") {
                  if (res.data[i].id != localStorage.getItem("printer")) {
                    continue;
                  }
                }

                const branch_data = localStorage.getItem("branch_data");
                const branch_data_json = JSON.parse(branch_data || "{}");
                let dataPrint = {
                  header: headerANDfooter.header,
                  footer: headerANDfooter.footer,
                  orderNo: data.documentNo,
                  orderId: data.id,
                  floorName,
                  orderType: ot,
                  orderDate: data.orderDate,
                  deliveryPerson,
                  tableName,
                  totalNet: data.totalNet,
                  data: res.data[i],
                  productList,
                  line,
                  paymeAmount,
                  printerModel: printerModel,
                  printer_models: [...printer_models],
                  customer: customer,
                  tokenNo: data.tokenNo,
                  couponNo: data.couponNo,
                  discountAmt: data.discountAmt,
                  taxAmt: data.taxAmt,
                  actualAmt: data.actualAmt,
                  isMinCharge: data.isMinCharge,
                  minCharge: data.minCharge,
                  paidAmt: data.paidAmt,
                  chargeType: data.chargeType,
                  isTaxOnChrg: data.isTaxOnChrg,
                  taxRate: data.taxRate,
                  payCash: data.payCash,
                  cashPaidAmount: cashPaidAmount,
                  comboList,
                  tax: data.taxAmt,
                  address: branch_data_json.address,
                  branch: branch_data_json.nameAr,
                  qrcode: qrcode,
                };
                createReceiptSlip(dataPrint, param);

                if (headerANDfooter.popupBeforePrint) {
                  const htmlContent = await generateInvoiceHTML(dataPrint);
                  Swal.fire({
                    title: "رسالة تأكيد",
                    html: `
          <div style="max-height: 70vh; overflow-y: auto; text-align: right;">
            ${htmlContent}
          </div>
        `,
                    showCancelButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "🖨️ طباعة",
                    cancelButtonText: "إلغاء",
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    width: "800px",
                    customClass: {
                      popup: "invoice-popup",
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      if (param == "payment") {
                        posStorageAction({ pos: true });
                      }
                      const printWindow = window.open("", "_blank");
                      printWindow.document.write(`
            <html>
              <head>
                <title>فاتورة</title>
                <style>
                  body { font-family: Arial, sans-serif; direction: rtl; margin: 0; padding: 0; }
                </style>
              </head>
              <body>
                ${htmlContent}
                <script>
                  window.onload = function() {
                    window.print();
                    window.onafterprint = function() { window.close(); }
                  }
                </script>
              </body>
            </html>
          `);
                      printWindow.document.close();
                    } else {
                      if (param == "payment") {
                        posStorageAction({ pos: true });
                      }
                    }
                  });
                } else {
                  if (param == "payment") {
                    posStorageAction({ pos: true });
                  }
                }
              } else if (param == "refund") {
                let dataPrint = {
                  header: headerANDfooter.header,
                  footer: headerANDfooter.footer,
                  orderNo: data.documentNo,
                  floorName,
                  tableName,
                  totalNet: data.totalNet,
                  data: res.data[i],
                  productList,
                  line,
                  refundAmount: data.refundAmt,
                  printerModel: printerModel,
                  printer_models: [...printer_models],
                  customer: customer,
                  tokenNo: data.tokenNo,
                  tax: data.taxAmt,
                  comboList,
                };
                createRefundSlip(dataPrint);
              }
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
};

export const cashUpPrint = async (data) => {
  var branch = JSON.parse(JSON.parse(localStorage.getItem("persist:root")).user)
    .branchId;
  var headerANDfooter = {};
  await axios({
    url: API_URL + "branchByID",
    method: "GET",
    params: {
      id: branch,
      lang: localStorage.getItem("lang"),
    },
    headers: {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    },
  }).then((result) => {
    headerANDfooter = result.data.object;
  });
  await axios({
    url: API_URL + "printerListByBranch",
    method: "GET",
    params: {
      branchId: branch,
    },
    headers: {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    },
  }).then(async (res) => {
    for (let i = 0; i <= res.data.length - 1; i++) {
      var isPrntReciept = res.data[i].isPrntReciept;
      if (isPrntReciept) {
        let array = [...data.cashPayments];
        let payments = [];
        let total = 0;
        array.forEach((item) => {
          let obj = {
            paymentAmt: item.paymentAmt,
            name: item.name,
            nameAr: item.nameAr,
          };
          total = total + item.paymentAmt;
          payments.push(obj);
        });
        let cashClosePrint = {
          header: headerANDfooter.header,
          footer: headerANDfooter.footer,
          printer: res.data[i].name,
          branch: data.branch,
          cashupDate: data.cashup.cashupDate,
          closeDate: data.cashup.closeDate,
          total: total,
          payments: [...payments],
        };
        await sendDynamicPrintToServer(cashClosePrint, "CASHUP");
      }
    }
  });
};

const generateQRCodeBase64 = async (value) => {
  console.log("Qr code value", value);
  try {
    return await QRCode.toDataURL(value, {
      errorCorrectionLevel: "M",
      scale: 4,
      margin: 1,
    });
  } catch (err) {
    console.error("QR error:", err);
    return "";
  }
};

const generateInvoiceHTML = async (data) => {
  const lines = Array.isArray(data.line) ? data.line : [];
  const logo = localStorage.getItem("clientLogo");
  const tobacco = JSON.parse(
    localStorage.getItem("saveSaleOrderTobacco") || "{}",
  );
  const tobaccoFeeBeforeTax = tobacco.netLineWithoutTax;

  const format = (v) => {
    const n = Number(v || 0);
    return isNaN(n) ? "0.00" : n.toFixed(2);
  };
  const classifyLines = (lines) => {
    const mainProducts = lines.filter((item) => !item.parentProduct);
    const childrenMap = {};

    lines.forEach((item) => {
      if (item.parentProduct) {
        if (!childrenMap[item.parentProduct])
          childrenMap[item.parentProduct] = [];
        childrenMap[item.parentProduct].push(item);
      }
    });

    return { mainProducts, childrenMap };
  };
  const { mainProducts, childrenMap } = classifyLines(lines);

  const linesHTML = mainProducts
    .map((item) => {
      const qty = Number(item.qty || 0);
      const unit = Number(
        item.unitPrice || item.price || item.priceWithoutTax || 0,
      );
      const lineTotal = Number(
        item.totalNetLine || item.total || qty * unit || 0,
      );

      const children = childrenMap[item.id] || [];

      const childrenHTML = children.length
        ? `<div style="margin-top:6px; padding-left:10px; text-align:right;">
        ${children
          .map((c) => {
            const cQty = Number(c.qty || 0);
            const cPrice = (c.price || c.unitPrice || 0).toFixed(2);
            return `<div style="font-size:12px; color:#555; margin:2px 0;">
                    <div>* ${c.productNameAr || c.productNameEn}</div>
                    <div style="display:flex; justify-content:space-between;">
                      <span style="font-size:12px; color:#777;">${cQty}</span>
                      <span style="font-size:12px; color:#777;">${cPrice}</span>
                    </div>
                  </div>`;
          })
          .join("")}
      </div>`
        : "";

      return `
    <div style="border-bottom:2px dashed #000; padding:8px 0; direction: rtl;">
      <div style="font-size:14px; color:#000; text-align:right; margin-bottom:6px;">${
        item.productNameAr
      }</div>
      <div style="display:flex; justify-content:space-between; align-items:center; gap:8px; direction: rtl;">
        <div style="font-size:14px; min-width:80px; text-align:center;">${lineTotal.toFixed(
          2,
        )}</div>
        <div style="font-size:14px; min-width:60px; text-align:center;">${unit.toFixed(
          2,
        )}</div>
        <div style="font-size:14px; min-width:40px; text-align:center;">${qty}</div>
      </div>
      <div style="font-size:14px; color:#000; text-align:right; margin-bottom:6px;">${
        item.productNameEn
      }</div>
      ${childrenHTML}
    </div>
  `;
    })
    .join("");
  const hasData = (value) => {
    return value !== undefined && value !== null && value !== "" && value !== 0;
  };
  const actualAmt = format(data.actualAmt);
  const taxAmt = format(data.taxAmt || data.tax);
  const taxNo = localStorage.getItem("taxNo")
    ? localStorage.getItem("taxNo")
    : "";
  const headerLogoHTML = logo
    ? `<div style="text-align:center; margin-bottom:10px;">
         <img src="${logo}" alt="logo" style="max-width:120px; max-height:120px; object-fit:contain; display:block; margin:0 auto 10px;" />
       </div>`
    : "";
  const barcodeImg = await generateQRCodeBase64(data.qrcode);
  const barcodeHTML = `
  <div style="text-align:center; margin-top:20px;">
    <img src="${barcodeImg}" style="max-width:120px; height:auto; object-fit:contain;" />
  </div>
`;
  return `
    <div style="width:100%; margin:0; direction:rtl; font-size:13px; color:#000; background:#fff; padding:8px; box-sizing:border-box;">
      ${headerLogoHTML}

      <div style="text-align:center; margin-bottom:10px;">
      <div style="
        font-size:24px;
        font-weight:bold;
        margin-bottom:5px;
        color:#000;
        text-align:center;
      ">
        فاتورة ضريبية مبسطة
      </div>
      <div style="
        font-size:18px;
        font-weight:bold;
        color:#000;
        text-align:center;
        ${!hasData(data.header) ? "display:none;" : ""}
      ">
        ${data.header}
      </div>
      <div style="
        font-size:18px;
        color:#000;
        text-align:center;
        margin-top:2px;
        ${!hasData(data.address) ? "display:none;" : ""}
      ">
        ${data.address}
      </div>
      <div style="
        font-size:18px;
        color:#000;
        text-align:center;
        margin-top:2px;
        ${!hasData(taxNo) ? "display:none;" : ""}
      ">
      الرقم الضريبي  ${taxNo}
      </div>
    </div>

   <div style="display:flex; justify-content:center; gap:14px; flex-wrap:wrap; margin-bottom:${12}px; direction:rtl;">
     <div style="border:2px solid #000; border-radius:12px; padding:${12}px; text-align:center; min-width:120px;">
      <div style="font-size:13px; color:#000;">فاتورة</div>
      <div style="font-size:${16}px; font-weight:600; margin-top:4px;">${data.orderNo ||
    "-"}</div>
      <div style="font-size:${16}px; color:#000; margin-top:4px;">
        طلب رقم: #${data.tokenNo}
      </div>
    </div>

     <div style="display:flex; flex-direction:column; justify-content:center; align-items:center; text-align:center;">
      <div style="font-size:${16}px; color:#000;">${data.customer ||
    "عميل غير محدد"}</div>
      <div style="font-size:${16}px; color:#000; margin-top:2px;">${data.orderType ||
    ""}</div>
      <div style="font-size:${16}px; color:#000; margin-top:2px;">${data.orderDate ||
    ""}</div>
    </div>
  </div>

  <div style="
      display:flex;
      justify-content:center;
      text-align:center;
      padding-top:${18}px;
      padding-bottom:${18}px;
      flex-direction:row-reverse;
      gap:6px;
    ">
    <div style="font-size:${16}px; color:#000;">${data.tableName}</div>
    <div style="font-size:${16}px; color:#000;">طاولة : </div>
    </div>

      <div style="display:flex; justify-content:space-between; border-bottom:2px dashed #000; padding-bottom:8px; margin-bottom:6px; direction:rtl;">
        <div style="width:80px; text-align:center; font-weight:600;">الإجمالي</div>
        <div style="width:60px; text-align:center; font-weight:600;">السعر</div>
        <div style="width:40px; text-align:center; font-weight:600;">الكمية</div>
      </div>

      <div style="max-height:380px; overflow:auto; direction:rtl;">
        ${linesHTML ||
          `<div style="text-align:center; color:#777; padding:8px 0;">لا توجد أصناف</div>`}
      </div>

      <div style="border: 2px dashed #000; padding: 10px; margin-top: 12px; direction: rtl;">
   <div
    style="display: flex; justify-content: space-between; margin-bottom: 6px; ${
      !hasData(tobaccoFeeBeforeTax) ? "display: none;" : ""
    }"
  >
    <div>رسوم تقديم التبغ:</div>
    <div>${tobaccoFeeBeforeTax}</div>
  </div>

  <!-- الاجمالي -->
  <div style="display: flex; justify-content: space-between; margin-bottom: 6px;">
    <div>الاجمالي:</div>
    <div>${actualAmt}</div>
  </div>

  <!-- الضريبة -->
  <div style="display: flex; justify-content: space-between; margin-bottom: 6px;">
    <div>الضريبة:</div>
    <div>${taxAmt}</div>
  </div>
</div>

         <div style="text-align:center; margin-top:10px;">
      ${barcodeHTML}
    </div>

       <div style="text-align:center; margin:20px 0; font-size:12px; color:#000;">${data.footer ||
         "شكرًا لزيارتكم"}</div>
    </div>
  `;
};
